import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MsalGuard} from "@azure/msal-angular";
import {BrowserUtils} from "@azure/msal-browser";
import {SupportControllerComponent} from "./shared/components";
import {
  UserNotFoundControllerComponent
} from "./shared/components/user-not-found/user-not-found-controller/user-not-found-controller.component";
import {AccessRestrictedComponent} from './shared/components/access-restricted/access-restricted.component';
import {ActiveFiuGuard} from './shared/guards/active-fiu.guard';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: ()=> import('./modules/dashboard/dashboard.module').then(m=> m.DashboardModule),
    canActivate: [MsalGuard, ActiveFiuGuard]
  },
  {
    path: 'case-management',
    loadChildren: ()=> import('./modules/case-management/case-management.module').then(m=> m.CaseManagementModule),
    canActivate: [MsalGuard, ActiveFiuGuard]
  },
  {
    path: 'working-groups',
    loadChildren: ()=> import('./modules/working-groups/working-groups.module').then(m=> m.WorkingGroupsModule),
    canActivate: [MsalGuard, ActiveFiuGuard]
  },
  {
    path: 'community-content',
    loadChildren: ()=> import('./modules/community-content/community-content.module').then(m=> m.CommunityContentModule),
    canActivate: [MsalGuard, ActiveFiuGuard]
  },
  {
    path: 'notifications',
    loadChildren: ()=> import('./modules/notifications/notifications.module').then(m=> m.NotificationsModule),
    canActivate: [MsalGuard, ActiveFiuGuard]
  },
  {
    path: 'chat',
    loadChildren: ()=> import('./modules/chat/chat.module').then(m=> m.ChatModule),
    canActivate: [MsalGuard, ActiveFiuGuard]
  },
  {
    path: 'users',
    loadChildren: ()=> import('./modules/users/users.module').then(m=> m.UsersModule),
    canActivate: [MsalGuard, ActiveFiuGuard]
  },
  {
    path: 'fiu-management',
    loadChildren: ()=> import('./modules/fiu-management/fiu-management.module').then(m=> m.FiuManagementModule),
    canActivate: [MsalGuard, ActiveFiuGuard]
  },
  {
    path: 'support',
    component: SupportControllerComponent,
    canActivate: [MsalGuard, ActiveFiuGuard]
  },
  {
    path: 'user-not-found',
    component: UserNotFoundControllerComponent,
    outlet: 'userNotFound',
    canActivate: [MsalGuard]
  },
  {
    path: 'access-restricted',
    component: AccessRestrictedComponent,
    canActivate: [MsalGuard]
  },
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full' }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // Don't perform initial navigation in iframes or popups
    initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
